import {Slider} from "../../../styleguide/js/components/slider/slider"

export const SliderDefaultSelector = '.wdf-slider';

export class SliderHomeComponent extends Slider {
    setOptions() {
        const options = {
            speed: 1500
        }
        super.setOptions(options);
    }
}
window.pew.addRegistryEntry({key: 'wdf-slider-home', domSelector: SliderDefaultSelector, classDef: SliderHomeComponent});



export const SliderContent = '.wdf-slider-content';

export class SliderContentComponent extends Slider {
    setOptions() {
        const options = {
            pager: false
        }
        super.setOptions(options);
    }
}
window.pew.addRegistryEntry({key: 'wdf-slider-content', domSelector: SliderContent, classDef: SliderContentComponent});



export const Slidervideos = '.wdf-slider-videos';

export class SliderVideosComponent extends Slider {
    setOptions() {
        const options = {
            mode: 'fade',
            touchEnabled: false
        }
        super.setOptions(options);
    }
}
window.pew.addRegistryEntry({key: 'wdf-slider-videos', domSelector: Slidervideos, classDef: SliderVideosComponent});
